export default {
  label: {
    filterTitle: 'Filtro de tags em árvore',
  },
};
